// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1EMPt","title":"Header_title__291MP","side":"Header_side__1FVuL"};